import useStorage from "./useStorage";

function useLocalStorage<T>(key: string, initialValue?: T) {
  const localStorage = useStorage("localStorage", key, initialValue);
  return localStorage;
}

export default useLocalStorage;
